function updatePageBackground() {
  const root = document.documentElement;
  const main = document.querySelector("main.main-content");
  if (!main) return;

  const atBottom = window.scrollY > 0 &&
    Math.ceil(window.scrollY + window.innerHeight) >= root.scrollHeight;
  const footer = document.querySelector("footer");
  const edge = atBottom && footer ? footer : main;

  root.style.backgroundColor = getComputedStyle(edge).backgroundColor;
}

document.addEventListener("turbo:load", updatePageBackground);
window.addEventListener("scroll", updatePageBackground, { passive: true });
window.addEventListener("resize", updatePageBackground);
